<script setup>
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';

import TableWithBusyState from '~/common/components/TableWithBusyState.vue';

defineProps({
  userCounts: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const fields = [
  { key: 'username', label: 'Username', sortable: true },
  { key: 'sum_added_labels', label: 'Labels Added', sortable: true, class: 'text-end' },
];
</script>

<template>
  <BAccordion class="mb-2">
    <BAccordionItem
      title="Leaderboard"
      :visible="true"
    >
      <div v-if="loading || userCounts.length > 0">
        <TableWithBusyState
          :items="userCounts"
          :fields="fields"
          :busy="loading"
          hover
          small
        />
      </div>
    </BAccordionItem>
  </BAccordion>
</template>
